export default class Journeys {

    constructor(
        processedJourneys,
        unprocessedJourneys,
        currentJourney,
        newJourney,
        unsnappedJourneys,
        lastActiveDate,
        vehicle,
    ) {
        this.processedJourneys = processedJourneys
        this.unprocessedJourneys = unprocessedJourneys
        this.currentJourney = currentJourney
        this.newJourney = newJourney
        this.unsnappedJourneys = unsnappedJourneys
        this.lastActiveDate = lastActiveDate
        this.vehicle = vehicle
    }

}
